import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import { getWebComponentInstance } from 'fg-frontend/src/webComponents/decorate'
import flatpickr from 'flatpickr';
// import RangePlugin from 'flatpickr/dist/plugins/rangePlugin';
import dateFormat  from 'date-fns/format';
import dateParse from 'date-fns/parse';
import addDays from 'date-fns/addDays';
import $ from 'jquery';
import compareAsc from 'date-fns/compareAsc'

export default class Datepicker extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputEvent = this.handleInputEvent.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleChangeSecondDatepicker = this.handleChangeSecondDatepicker.bind(this);
    this.handleChangeFromDatepicker = this.handleChangeFromDatepicker.bind(this);
  }

  didMount() {
    const {
      rangeWith,
      locale,
      format,
      ...props
    } = this.props;

    const plugins = [];

    this.on('blur', this.handleInputChange);
    this.on('input', this.handleInputEvent);
    this.flatpickr = flatpickr(this.element, {
      ...props,
      locale: locale === 'en' ? null : locale,
      plugins,
    });

    this.flatpickr.config.onOpen.push(this.handleOpen);
    this.flatpickr.config.onClose.push(this.handleClose);

    if (rangeWith != null) {
      // plugins.push(new RangePlugin({ input: rangeWith }));
      this.secondDatePicker = document.querySelector(rangeWith);
      this.secondDatePicker.addEventListener('change', this.handleChangeSecondDatepicker)
      this.element.addEventListener('change', this.handleChangeFromDatepicker)
    }
  }
  handleChangeFromDatepicker (e) {
    const {
      parseDate, dateFormat
    } = this.props;
    const instanceTo = getWebComponentInstance(this.secondDatePicker);
    const date = parseDate(e.target.value, dateFormat);
    const isValidDate = !isNaN(date);
    const value = instanceTo.element.value;
    instanceTo.flatpickr.set('minDate', isValidDate ? date : null);
    instanceTo.flatpickr.redraw();

  }
  handleChangeSecondDatepicker (e) {
    // if (e.isTrusted) {
      const {
        parseDate, dateFormat,
      } = this.props;
      const date = parseDate(e.target.value, dateFormat);
      const value = this.element.value;
      const isValidDate = !isNaN(date);
      this.flatpickr.set('maxDate', isValidDate ? date : null);
      this.flatpickr.redraw();
      if (value === '') {
        // this.flatpickr.setDate('', false);
      }
    //}
  }
  handleOpen(){
    this.setState({
      open: true,
    });
  };
  handleClose() {
    this.setState({
      open: false,
    });
  };

  willUnMount() {
    clearTimeout(this.hideTimeoutTimer);
    this.flatpickr.destroy();
  }

  handleInputEvent(e) {
    e.stopPropagation();
    if (e.target.value === '') {
      this.flatpickr.setDate('', false);
      this.dispatchChangeEvent();
    }
  };
  handleInputChange(e) {
    const { parseDate, dateFormat, clearInvalidDate } = this.props;
    if (e.isTrusted && e.target.value) {
      const date = parseDate(e.target.value, dateFormat);
      const isValidDate = !isNaN(date);
      if (isValidDate) {
        this.flatpickr.setDate(date, false);
      }
      if (!isValidDate && clearInvalidDate) {
        e.target.value = '';
        this.flatpickr.setDate('', false);
      }
      e.stopPropagation();
    }
  };

  update() {
    const {
      open,
    } = this.state;
    this.element.dataset.stateOpen = open;
  }
}

Datepicker.defaultProps = {
  hideTimeout: 200,
  locale: 'cs',
  allowInput: true,
  altInput: false,
  dateFormat: 'd/m/Y',
  time_24hr: true,
  minuteIncrement: 5,
  hourIncrement: 1,
  altFormat: 'd. M. yyyy',
  ariaDateFormat: 'd. M. yyyy',
  clearInvalidDate: false,
  formatDate: (date, format) => {
    return dateFormat(date, format);
  },
  parseDate: (value, format) => {
    return dateParse(value, format, new Date());
  },
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Datepicker.js